import React from "react";
import { Link as ScrollLink } from "react-scroll";
import { Link as RouterLink, useLocation } from "react-router-dom";

function Header() {
  const location = useLocation();

  // Function to close the dropdown menu
  const handleLinkClick = () => {
    const navbarCollapse = document.getElementById("navbarNav");
    if (navbarCollapse && navbarCollapse.classList.contains("show")) {
      navbarCollapse.classList.remove("show");
    }
  };

  return (
    <header>
      <nav className="navbar navbar-expand-lg bg-white fixed-top">
        <div className="container">
          {location.pathname !== "/" ? (
            <RouterLink
              className="nav-link text-dark navbar-brand cursor-pointer"
              to="/"
              onClick={handleLinkClick}
            >
              <img src="/image/logo.png" alt="logo" height={40} />
            </RouterLink>
          ) : (
            <ScrollLink
              className="nav-link text-dark navbar-brand cursor-pointer"
              to="hero"
              smooth={true}
              duration={500}
              activeClass="active-link"
              spy={true}
              onClick={handleLinkClick}
            >
              <img src="/image/logo.png" alt="logo" height={40} />
            </ScrollLink>
          )}
          <button
            className="navbar-toggler border-0"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav ms-md-auto me-md-5 d-flex align-items-center justify-content-center text-center">
              <li className="nav-item my-1 my-lg-0">
                <RouterLink
                  className="nav-link text-dark"
                  to="/about"
                  // smooth={true}
                  // duration={500}
                  // activeClass="active-link"
                  // spy={true}
                  onClick={handleLinkClick}
                >
                  About Me
                </RouterLink>
              </li>
              <li className="nav-item my-1 my-lg-0">
                {/* <ScrollLink
                  className="nav-link text-dark"
                  to="work"
                  smooth={true}
                  duration={500}
                  activeClass="active-link"
                  spy={true}
                  onClick={handleLinkClick}
                >
                  My Work
                </ScrollLink> */}
                {location.pathname !== "/" ? (
                  <RouterLink
                    className="nav-link text-dark navbar-brand"
                    to="/"
                    onClick={handleLinkClick}
                  >
                    My Work
                  </RouterLink>
                ) : (
                  <ScrollLink
                    className="nav-link text-dark"
                    to="work"
                    smooth={true}
                    duration={500}
                    activeClass="active-link"
                    spy={true}
                    onClick={handleLinkClick}
                  >
                    My Work
                  </ScrollLink>
                )}
              </li>
              {/* <li className="nav-item my-1 my-lg-0">
                <ScrollLink
                  className="nav-link text-dark"
                  to="contact"
                  smooth={true}
                  duration={500}
                  activeClass="active-link"
                  spy={true}
                  onClick={handleLinkClick}
                >
                  Contact
                </ScrollLink>
              </li> */}
              {location.pathname !== "/" ? (
                <RouterLink
                  className="nav-link text-dark navbar-brand"
                  to="/"
                  onClick={handleLinkClick}
                >
                  Contact
                </RouterLink>
              ) : (
                <ScrollLink
                  className="nav-link text-dark"
                  to="contact"
                  smooth={true}
                  duration={500}
                  activeClass="active-link"
                  spy={true}
                  onClick={handleLinkClick}
                >
                  Contact
                </ScrollLink>
              )}
            </ul>
          </div>
        </div>
      </nav>
    </header>
  );
}

export default Header;
